import { useState, useEffect, Fragment } from "react";
import useStyles from "./styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import BusinessOutlinedIcon from "@material-ui/icons/BusinessOutlined";
import Avatar from "@material-ui/core/Avatar";

const LoginBrand = ({ returnUrl, ...props }: any) => {
    var classes = useStyles();
    const urlBase: string = `/api/clientapp`;

    const [brands, setBrands] = useState<string[]>([]);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        const llamada3 = fetch(`${urlBase}/Brands?ReturnUrl=${encodeURIComponent(
            returnUrl
        )}`, {
            method: "GET",
            credentials: "include",
            headers: { "Content-Type": "application/json", Caller: "EOS" },
        })
            .then((llamada) => llamada.json())
            .then((data) => {
                if (data.length > 1) {
                    setBrands(data);
                    setLoading(false);
                } else {
                    setLoading(true);
                    MultiTenantLogin(data[0]);
                }
            });
            return () => {
                setBrands([]);
                setLoading(true);
              };
    }, []);

    const SendCode = async (e: any, brand: string) => {
        e.stopPropagation();
        e.preventDefault();
        setBrands([]);

        MultiTenantLogin(brand);
    };

    const MultiTenantLogin = async (brand: string) => {
        const response = await fetch(
            `/api/authenticate/multitenantlogin/?selectedTenant=${brand}&ReturnUrl=${encodeURIComponent(
                returnUrl
            )}`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
            }
        );

        if (response.ok) {
            const data = await response.json();
            if (data) {
                window.location.href = `${returnUrl}`;
            }
        }
    };

    return (
        <Fragment>
            {loading ? (
                <Fragment>
                    <Typography component="h1" variant="h5">
                        Lo estamos redirigiendo a su aplicación, por favor
                        espere 😊!!
                    </Typography>
                </Fragment>
            ) : (
                <Fragment>
                    <Avatar className={classes.avatar}>
                        <BusinessOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Por favor seleccione una marca
                    </Typography>
                    <form className={classes.formBrands} noValidate>
                        {brands.map((brand, index) => (
                            <div key={index} style={{flex: '1 1 30px', marginTop: 20}}>
                                <Button
                                    type="button"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submitBrands}
                                    
                                    onClick={(e: any) => SendCode(e, brand)}
                                >
                                    {brand}
                                </Button>
                            </div>
                        ))}
                    </form>
                </Fragment>
            )}
        </Fragment>
    );
};

export default LoginBrand;
